import { render } from "./AppList.vue?vue&type=template&id=96f881be&scoped=true"
import script from "./AppList.vue?vue&type=script&lang=js"
export * from "./AppList.vue?vue&type=script&lang=js"

import "./AppList.vue?vue&type=style&index=0&id=96f881be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f881be"]])

export default __exports__